import store from "@/store";

import { useDark, useToggle } from "@vueuse/core";
export const createDark = ()=>{
  return useDark({ storageKey: 'home-theme-val', });
}

export const initThemeScheme = ()=>{
  const isDark = createDark();
  isDark.value = false;
  updateThemeScheme(isDark);
}
export const updateThemeScheme = (isDark)=>{
  useToggle(isDark);
  store.dispatch('themeScheme/themeToggle', isDark.value);
}